import { lazy } from "react";

export { prototypeMeta } from "./meta";

export default lazy(() => import("./Page"));
